// extracted by mini-css-extract-plugin
module.exports = {"navigation":"ob_P74R8S","scrollIndicator":"ob_lj7FYC","navigation__list":"ob_7TUJAY","navItem":"ob_JTNNB3","selected":"ob_BMbyo8"};